exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link :hover {\n  color: #006687;\n}\n.link {\n  color: #008cba;\n  float: right;\n}\n\n.alert-icon {\n  font-size: 40px;\n  color: red;\n  padding-right: 10px;\n}\n.alert-modal-body {\n  display: flex;\n  align-items: center;\n  padding: 5px 15px;\n}\n.alert-modal-footer {\n  padding: 5px 15px;\n}\n", ""]);

// exports
